<app-task-panel
    [(visible)]="taskPanelVisible"
    [selectedTask]="selectedTask"
    (onTaskPanelHide)="onTaskPanelHide()"
    (taskSaved)="onTaskSaved()">
</app-task-panel>

